export const ru = {
    from: 'от',
    to: 'до',
};
